import { ComponentsOverrides } from '@mui/material/styles/overrides';
import colors from '../theme/colors';
import { INPUT_BORDER_RADIUS, INPUT_WIDTH } from '../theme/constants';

const styleOverrides: ComponentsOverrides['MuiTextField'] = {
  root: ({ ownerState }) => ({
    ...(ownerState.size === 'xs' && {
      width: INPUT_WIDTH.XS,
    }),
    ...(ownerState.size === 'date' && {
      width: INPUT_WIDTH.DATE,
    }),
    ...(ownerState.size === 'small' && {
      width: INPUT_WIDTH.SMALL,
    }),
    ...(ownerState.size === 'medium' && {
      width: INPUT_WIDTH.MEDIUM,
    }),
    ...(ownerState.size === 'large' && {
      width: INPUT_WIDTH.LARGE,
    }),
    ...(ownerState.fullWidth === true && {
      width: INPUT_WIDTH.FULL,
    }),
    ...(!ownerState.fullWidth &&
      !ownerState.size && {
        width: INPUT_WIDTH.MEDIUM,
      }),
    maxWidth: '100%',
    '& fieldset': {
      borderRadius: INPUT_BORDER_RADIUS,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: colors.transparentGray['400'],
      },
    },
    'input[type="search"]::-webkit-search-cancel-button': {
      WebkitAppearance: 'none',
    },
  }),
};

export default styleOverrides;
